import { GAME_ID, REDUX_ACTIONS, playButtonIcons, fastForwardButtonIcons } from '../../../data/constants';

export const initialState = {
  playButtonIcon: playButtonIcons.PLAY,
  fastForwardButtonIcon: fastForwardButtonIcons.NEXT,
  fastForwardButtonVisible: false,
  fastForwardButtonEnabled: true, // when false, fastForward button will render semi-transparent.
};

const buttonsReducer = (state = initialState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.SET_PLAY_BUTTON_ICON:
      return {
        ...state,
        playButtonIcon: payload,
      };

    case REDUX_ACTIONS.SET_FAST_FORWARD_BUTTON_ICON:
      return {
        ...state,
        fastForwardButtonIcon: payload,
      };

    case REDUX_ACTIONS.SET_FAST_FORWARD_BUTTON_VISIBLE:
      return {
        ...state,
        fastForwardButtonVisible: payload,
      };

    case REDUX_ACTIONS.SET_FAST_FORWARD_BUTTON_ENABLED:
      return {
        ...state,
        fastForwardButtonEnabled: payload,
      };

    case REDUX_ACTIONS.CHANGE_SCREEN:
      return { ...initialState };

    default:
      return state;
  }
};

export default buttonsReducer;
